import { DoctorRanks } from "../Constants/DoctorRanks";

export const SelectACaseUnlocks: Array<number> = [
    null, // unlocked by default
    null, // unlocked by default
    1, // Med Student
    3  // Junior Resident
];

export function getCaseAmountsFromXP(_xp: number): number {
    let amount = 0;
    SelectACaseUnlocks.forEach((e) => {
        if(!e) {
            amount++;
            return;
        }
        const rank = DoctorRanks[e];
        if(rank.threshold <= _xp) {
            amount++;
        }
    });
    return amount;
}